import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import * as resActions from "../../../modules/resources";
import Loader from "Components/loader/Loader";
import withAutoRefresh from "Components/withAutoRefresh";
import PropTypes from "prop-types";
import { t } from "i18next";
import { displayFormattedDate } from "Utils/dateFormats";
import Settings from "./Settings";
import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";
import s from "./showEmailAccounts.scss";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};

class ArchiveDomainListScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfo: this.props.isMediaMobile ? false : true
    };
    this.toggleInfo = this.toggleInfo.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.getEmailAccount(
      this.props.match.params.domainCode,
      this.props.match.params.emailCode
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true
      });
    }
  }

  goBack() {
    let path = `/archive/domains/${this.props.match.params.domainCode}/email_accounts`;
    this.props.history.push(path);
  }

  toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  render() {
    const { emailAccount, isEmailAccountLoading, location, params } = this.props;

    const { showInfo } = this.state;

    const {
      getLoggedUserType,
      isMobileDevice,
      isMediaMobile,
      isMediaSM,
      isMediaMD,
      isMediaLG
    } = this.context;

    if (isEmailAccountLoading) {
      return <Loader {...this.props} />;
    }

    return (
      <div className={s.showEmailAccounts}>
        <div className={s.navigation}>
          {getLoggedUserType() !== "Postmaster" ? <ButtonBack onClick={this.goBack} /> : <div />}
          <div className={s.viewSectionLabel}>{t("section.view.archive.account.email")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">
              {emailAccount.lastname
                ? emailAccount.firstname + " " + emailAccount.lastname
                : emailAccount.firstname}
            </div>

            {isMediaMobile() && (
              <div className="internalLink" onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>
          {showInfo && (
            <div className={s.subtitle}>
              <DetailStatus status={emailAccount.archive_status} />
              <div className="sectionDesc">{emailAccount.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={emailAccount.code} inLine />
              <DetailInfo
                label={t("detailInfo.label.created")}
                info={
                  emailAccount.archive_activated_at &&
                  displayFormattedDate(emailAccount.archive_activated_at)
                }
                inLine
              />
            </div>
          )}
        </div>
        <div className={s.settings}>
          <Settings
            {...this.props}
            emailAccount={emailAccount}
            isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
          />
        </div>
      </div>
    );
  }
}

//ArchiveDomainListScreen.propTypes = propTypes;
ArchiveDomainListScreen.contextTypes = ContextTypes;

const mapStateToProps = state => ({
  emailAccount: resActions.getData("email_account.data.0", state),
  isEmailAccountLoading: resActions.isResourceLoading("email_account", state)
});

const mapDispatchToProps = dispatch => ({
  changeArchiveImportStatus: (resourceCode, newValue) =>
    dispatch(
      resActions.changeAttribute(newValue, {
        resourcesType: "email_account",
        resourceCode,
        resourceAttribute: "archive_import_status"
      })
    ),
  getEmailAccount: (code, codeEmail) =>
    dispatch(resActions.callApi("getEmailAccount", "email_account", code, codeEmail))
});

const refreshConditionFunc = props => {
  const statuses = ["activating", "disabling", "enabling", "deleting", "updating"];
  const enqueued = _.filter(
    props.domains,
    d =>
      statuses.includes(d.status) ||
      (d.status === "ownership_check" && d.status_detail === "verifying")
  );
  return enqueued.length > 0 && !props.areDomainsLoading;
};

const onRefreshFunc = props => {
  props.refreshDomains(props.location.search);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAutoRefresh(ArchiveDomainListScreen, refreshConditionFunc, onRefreshFunc));
